import React, { useContext } from 'react';
import ym from 'react-yandex-metrika';

import { Main, Button } from '@/components';
import { Logo } from '@/icons';
import { PageContext } from '@/Page';

import styles from './header.module.scss';

const Header: React.FC = () => {
  const { handleOpen } = useContext(PageContext);

  const handleClick = () => {
    handleOpen();
    ym('reachGoal', 'leave_request');
  };

  return (
    <header className={styles.header}>
      <Main>
        <a
          href='https://novosibirsk.fitauto.ru/'
          target='_blank'
          rel='noreferrer'
          className={styles.header__logo}
        >
          <Logo className={styles.header__icon} />
        </a>
        <Button variant='text' onClick={handleClick}>
          Оставить заявку
        </Button>
      </Main>
    </header>
  );
};

export default Header;
